import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-4 py-8 sm:py-16 items-center justify-center pl-[20px] pr-[20px] pt-[20px] pb-[20px]" style={{
    background: 'linear-gradient(135deg, #0a0a0a 0%, #0a1510 30%, #0a100d 60%, #0a0a0a 100%)'
  }} data-id="element-247">
      {/* Logo */}
      <div className="mb-4" data-id="element-248">
        <span className="text-[#00E68A] text-xl sm:text-2xl font-black tracking-widest" data-id="element-249">
          🌟 PROFEPACK
        </span>
      </div>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-[320px] sm:max-w-2xl md:max-w-4xl lg:max-w-5xl sm:text-5xl md:text-7xl lg:text-8xl mb-[0px] text-[28px] leading-[1.1]" style={{
      textWrap: 'balance'
    } as React.CSSProperties} data-id="element-250">
        Todo tu año de Lengua y Literatura de Secundaria{' '}
        <span className="text-[#00E68A]" data-id="element-251">resuelto.</span>
      </h1>

      {/* Mockup image — LCP element, priority load with explicit dimensions */}
      <div className="w-full max-w-[240px] sm:max-w-[300px] md:max-w-sm mx-auto mb-4" style={{
      aspectRatio: '1/1'
    }} data-id="element-252">
        <img src="https://cdn.magicpatterns.com/uploads/vr3KC8yiXatQjgH9shXDA9/Sin_titulo_(420_x_420_px)_(4).png" alt="PROFEPACK Megapack Lengua y Literatura — Combo Completo" className="w-full h-full object-contain" width={400} height={400} fetchPriority="high" data-id="element-253" />
      </div>

      {/* Subtitle */}
      <p className="text-[#00E68A] text-lg sm:text-2xl font-bold max-w-3xl mb-[10px]" data-id="element-254">
        "Listo para usar. Sin buscar más. Sin improvisar. Sin perder domingos."
      </p>

      {/* Body */}
      <p className="text-white sm:text-lg max-w-2xl mb-[2px] pt-[8px] pb-[8px] text-[16px]" data-id="element-255">
        El sistema para docentes de Lengua y Literatura de secundaria en
        Argentina: año completo listo (actividades + evaluaciones +
        solucionarios), sin buscar ni armar desde cero.
      </p>

      {/* Pills */}
      <div className="flex flex-nowrap mb-[10px] gap-[4px] sm:gap-[6px] flex-row items-center justify-center" data-id="element-256">
        <span className="bg-black/50 border border-white/20 text-white text-[8px] sm:text-sm font-semibold px-1.5 sm:px-3 py-0.5 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-257">
          📄 100% PDF
        </span>
        <span className="bg-black/50 border border-white/20 text-white text-[8px] sm:text-sm font-semibold px-1.5 sm:px-3 py-0.5 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-258">
          ⚡ Acceso inmediato
        </span>
        <span className="bg-black/50 border border-white/20 text-white text-[8px] sm:text-sm font-semibold px-1.5 sm:px-3 py-0.5 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-259">
          🇦🇷 Currículo argentino
        </span>
        <span className="bg-black/50 border border-white/20 text-white text-[8px] sm:text-sm font-semibold px-1.5 sm:px-3 py-0.5 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-260">
          📚 1° a 6° año
        </span>
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="btn-bordo-pulse bg-[#00E68A] text-gray-900 font-black text-base sm:text-2xl px-6 sm:px-10 py-4 sm:py-5 rounded-xl hover:bg-[#00CC7A] transition-colors inline-block mb-5 w-full sm:w-auto max-w-sm" data-id="element-261">
        🌟 → QUIERO MI PROFEPACK AHORA
      </a>

      {/* Trust badges */}
      <p className="text-gray-300 text-xs sm:text-sm flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-262">
        <span data-id="element-263">🛡️ Garantía 7 días sin preguntas</span>
        <span data-id="element-264">🔒 Pago 100% seguro</span>
        <span data-id="element-265">💳 Mercado Pago | Tarjeta | Transferencia</span>
      </p>
    </section>;
}